module.exports = __webpack_public_path__ + "assets/images/coin-50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/coin-50.png
// module id = 1508
// module chunks = 1